import type { UseQueryResult } from "@tanstack/react-query";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { retryQueryOnUnauthorizedError } from "app/pages/sales-intelligence/query/utils";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { IRowsDtoWrapper } from "../../types/rowsDtoWrapper";
import type { ITopCompanyItem } from "../../types/TopCompany";
import { topCompaniesQueryKeys } from "../queryKeys/queryKeyFactory";

function useTopCompaniesListQuery(): UseQueryResult<readonly ITopCompanyItem[], unknown> {
    return useQuery({
        queryKey: topCompaniesQueryKeys.companiesList(),
        placeholderData: keepPreviousData,
        retry: retryQueryOnUnauthorizedError,
        select: (data: IRowsDtoWrapper<readonly ITopCompanyItem[]>) => data?.rows,
        queryFn({ signal }) {
            return salesApiService.home.fetchTopCompanies({
                cancellation: signal,
            });
        },
    });
}

export default useTopCompaniesListQuery;
